var map = {
	"./about/1925new.jpg": 5903,
	"./brand/NEWNEWLOGO.png": 3918,
	"./gallery/barnes1.jpg": 5291,
	"./gallery/barnes2.jpg": 5281,
	"./gallery/barnes3.jpg": 1366,
	"./gallery/gallery1.jpg": 8178,
	"./gallery/inside.jpg": 8826,
	"./gallery/rekean1.jpg": 9612,
	"./gallery/rekean2.jpg": 9007,
	"./gallery/rekean3.jpg": 1442,
	"./services/Commercial/barnes1.jpg": 623,
	"./services/Commercial/commercial-interior1.jpg": 6463,
	"./services/Commercial/commercial-office1.jpg": 6491,
	"./services/Commercial/commercial-space1.jpg": 9324,
	"./services/Epoxy Floors/barnes1.jpg": 7588,
	"./services/Epoxy Floors/epoxy-floor1.jpg": 2509,
	"./services/Epoxy Floors/epoxy-modern1.jpg": 6524,
	"./services/Epoxy Floors/epoxy-space1.jpg": 1668,
	"./services/Maintenance/barnes1.jpg": 4561,
	"./services/Maintenance/maintenance-detail1.jpg": 760,
	"./services/Maintenance/maintenance-exterior1.jpg": 1070,
	"./services/Maintenance/maintenance-home1.jpg": 5904,
	"./services/Painting/barnes1.jpg": 3969,
	"./services/Painting/barnes2.jpg": 4296,
	"./services/Painting/barnes3.jpg": 5646,
	"./services/Painting/gallery1.jpg": 4993,
	"./services/Painting/inside.jpg": 8108,
	"./services/Painting/rekean1.jpg": 7846,
	"./services/Painting/rekean2.jpg": 6864,
	"./services/Painting/rekean3.jpg": 1737,
	"./services/Plaster/newkean2.jpg": 7323,
	"./services/Plaster/plaster-interior1.jpg": 3084,
	"./services/Plaster/plaster-texture1.jpg": 3018,
	"./services/Plaster/plaster-wall1.jpg": 7686,
	"./services/Wallpaper/barnes1.jpg": 2553,
	"./services/Wallpaper/wallpaper-detail1.jpg": 4213,
	"./services/Wallpaper/wallpaper-pattern1.jpg": 6056,
	"./services/Wallpaper/wallpaper-room1.jpg": 1790,
	"./services/Wood Finishing/barnes1.jpg": 8099,
	"./services/Wood Finishing/wood-detail1.jpg": 8155,
	"./services/Wood Finishing/wood-finish1.jpg": 2402,
	"./services/Wood Finishing/wood-interior1.jpg": 5299,
	"./showroom/studio2.jpg": 4528
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;